/* eslint-disable jsx-a11y/anchor-is-valid */
import "./styles/Notifications.scss";

import React, { Component } from "react";
import {
  cancelNotification,
  getNotification,
  listNotifications,
} from "../api/notifications";
import Loading from "./Loading";
import moment from "moment";
import { confirmAlert } from "react-confirm-alert";
import RecipientViewer from "./RecipientViewer";
import { confirmationDialog } from "./ConfirmationDialog";
import { withRouter } from "react-router-dom";
import NotificationAnswersSection from "./NotificationAnswersSection";

class Notifications extends Component {
  constructor(props) {
    super(props);

    this.state = {
      notifications: undefined,
      selectedNotificationId: undefined,
      isLoading: false,
      notification: undefined
    };
  }

  componentDidMount() {
    this.fetchNotificationList();
    // this.interval = setInterval(() => this.fetchData(), 30000);
  }

  componentWillUnmount() {
    // clearInterval(this.interval);
  }

  setLoading = () => this.setState({ isLoading: true });
  stopLoading = () => this.setState({ isLoading: false });

  fetchNotificationList = () => {
    listNotifications()
      .then((res) => {
        this.setState({ notifications: res });
        if (res.length > 0) this.onSelectNotification(res[0].id);
      })
      .catch((err) => {
        // TODO show error
      });
  };

  deleteNotification = (notificatioNId) => {
    this.setState({ selectedNotificationId: undefined });
    cancelNotification(notificatioNId).then((res) => {
      listNotifications()
        .then((res) => {
          this.setState({ notifications: res });
        })
        .catch((err) => {
          // TODO show error
        });
    });
  };

  fetchNotification = (notificationId) => {
    getNotification(notificationId)
      .then((res) => {
        this.setState({
          notification: res,
          isLoading: false,
        });
      })
      .catch((err) => {
        // TODO show error
      });
  };

  onSelectNotification = (notificationId) => {
    this.setLoading();
    this.setState({ selectedNotificationId: notificationId, isLoading: true });
    this.fetchNotification(notificationId);
  };

  onSelectRecipients = () => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <RecipientViewer
            onClose={onClose}
            notificationId={this.state.notification.id}
          />
        );
      },
    });
  };

  
  render() {
    const renderNotificationListDesktop = () => {
      if (!this.state.notifications)
        return (
          <div className="is-flex is-justify-content-center ">
            <Loading />
          </div>
        );

      return (
        <ul className="menu-list">
          {this.state.notifications.map((n) => (
            <li
              className="notification"
              key={n.id}
              onClick={() => this.onSelectNotification(n.id)}
            >
              <a
                className={
                  n.id === this.state.selectedNotificationId ? "is-active" : ""
                }
              >
                {n.title}

                {n.isCanceled && (
                  <span className="tag is-info ml-2">Canceled</span>
                )}
              </a>
            </li>
          ))}
        </ul>
      );
    };

    const renderNotificationListMobile = () => {
      if (!this.state.notifications)
        return (
          <div className="is-flex is-justify-content-center ">
            <Loading />
          </div>
        );

      return (
        <>
          <p className="menu-label">Select Notification</p>
          <div className="select is-fullwidth">
            <select onChange={(e) => this.onSelectNotification(e.target.value)}>
              {this.state.notifications.map((n) => (
                <option key={n.id} value={n.id}>
                  {n.title}
                </option>
              ))}
            </select>
          </div>
        </>
      );
    };

    const renderNoNotificationSelected = () => {
      let text;
      if (!this.state.notifications) {
        text = "Loading notifications...";
      } else {
        if (this.state.notifications.length === 0) {
          text = "No notifications created yet...";
        } else {
          text = "Select a Notification";
        }
      }

      return (
        <div
          className="container is-flex is-justify-content-center is-align-items-center "
          style={{ height: "100%" }}
        >
          <h5 className="title">{text}</h5>
        </div>
      );
    };

    const notification = this.state.notification;

    const renderSelectedNotification = () => {
      if (this.state.isLoading)
        return (
          <div className="is-flex is-justify-content-center mt-5">
            <div>
              <Loading />
            </div>
          </div>
        );

      const isAlreadySent = moment(notification.sentAt).isBefore(moment());

      const sentOrWillBeSentSection = () => {
        if (isAlreadySent) {
          return (
            <>
              {" "}
              Sent{" "}
              <span
                data-tooltip={moment(notification.sentAt).format(
                  "YYYY-MM-DD HH:mm:ss"
                )}
              >
                {moment(notification.sentAt).fromNow()}.
              </span>
            </>
          );
        } else {
          if (notification.isCanceled) {
            return (
              <div className="is-flex is-inline-block ml-3">Canceled.</div>
            );
          }
          return (
            <div className="is-flex is-inline-block ml-3">
              Will be sent{" "}
              <span
                data-tooltip={moment(notification.sentAt).format(
                  "YYYY-MM-DD HH:mm:ss"
                )}
              >
                {moment(notification.sentAt).fromNow()}
              </span>
              .
              <a
                className="is-danger is-small ml-3"
                onClick={() => {
                  confirmationDialog(
                    {
                      title: "Cancel notification",
                      text:
                        "Are you sure you want to cancel this notification?",
                      positiveText: "Yes",
                      positiveColor: "danger",
                      negativeText: "No",
                      negativeColor: "info",
                    },
                    () =>
                      this.deleteNotification(this.state.selectedNotificationId)
                  );
                }}
              >
                Cancel
              </a>
            </div>
          );
        }
      };

      return (
        <div>
          <div className="section pb-3">
            <h5 className="title">{notification.title}</h5>

            {notification.isCanceled && (
              <p className="mb-2">
                <span
                  className="tag is-danger has-tooltip-arrow has-tooltip-multiline has-tooltip-right"
                  data-tooltip="This notification has been canceled."
                >
                  Canceled
                </span>
              </p>
            )}

            <div className="help is-flex is-inline-block">
              Created{" "}
              <span
                data-tooltip={moment(notification.createdAt).format(
                  "YYYY-MM-DD HH:mm:ss"
                )}
              >
                {moment(notification.createdAt).fromNow()}
              </span>
              .{sentOrWillBeSentSection()}
            </div>
          </div>

          <div className="section pt-3">
            <label className="label">Message</label>
            <p className="">{notification.message}</p>

            <div className="columns is-multiline mt-2">
              <div className="column is-4 ">
                <div className="field mt-5">
                  <label className="label">Expected Responses</label>

                  {notification.ExpectedResponses.length > 0 && (
                    <div className="field is-grouped is-grouped-multiline mt-4">
                      {notification.ExpectedResponses.map((er) => (
                        <div key={er.id} className="control">
                          <div className="tags">
                            <span className="tag is-info">{er.text}</span>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}

                  {notification.ExpectedResponses.length === 0 && (
                    <p className="help is-info">No expected responses.</p>
                  )}

                  {notification.allowOpenText && (
                    <p className="help is-info">Allow open text responses</p>
                  )}
                  {notification.allowMultipleChoice && (
                    <p className="help is-info">
                      Allow multiple choice responses
                    </p>
                  )}
                </div>
              </div>

              <div className="column is-4 has-text-centered">
                <div className="field mt-5">
                  <label className="label">Response Deadline</label>

                  {notification.respondUntil !== undefined &&
                    (notification.respondUntil === null ? (
                      <p className="help">
                        <span>No deadline</span>.
                      </p>
                    ) : (
                      <p className="help">
                        <span
                          data-tooltip={moment(
                            notification.respondUntil
                          ).format("YYYY-MM-DD HH:mm:ss")}
                        >
                          {moment(notification.respondUntil).fromNow()}
                        </span>
                        .
                      </p>
                    ))}
                </div>
              </div>

              <div className="column is-4 has-text-centered">
                <div className="field mt-5">
                  <label className="label">Recipient Groups</label>

                  <p className="control is-inline-block is-align-content-center">
                    <button
                      className="button is-small is-info"
                      onClick={this.onSelectRecipients}
                    >
                      View {notification.recipientsCount}
                    </button>
                  </p>
                </div>
              </div>
            </div>
          </div>
          
          {notification.isSent && <NotificationAnswersSection notification={notification} />}
          {!notification.isSent && <> 
            <div className="section">
              <h5 className="subtitle">This notifcation has not been sent yet. </h5>
            </div>
          </>}
          
        </div>
      );
    };

    return (
      <div>
        <div className="columns is-fullheight mx-3 ">
          <section className="section is-flex is-hidden-tablet notification-selector-container is-flex-direction-column pb-2">
            {renderNotificationListMobile()}
          </section>

          <aside className="menu column is-3 side-menu is-hidden-mobile">
            <p className="menu-label">Select Notification</p>
            {renderNotificationListDesktop()}
          </aside>

          <div className="container ml-4 column is-9 is-scrollable main-content">
            {this.state.selectedNotificationId !== undefined
              ? renderSelectedNotification()
              : renderNoNotificationSelected()}
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(Notifications);
